import styled from 'styled-components';
import { mobileQuery } from '../../../utils';
import { Ticket } from './Ticket';
import { infoStore } from '../../../store/infoStore';

export const MainEvent = ({ goOfflineTab }: { goOfflineTab: () => void }) => {
  const { info } = infoStore();
  return (
    <>
      <ImgContainer>
        <WelcomeText>메인 이벤트 참가 티켓 획득을 축하합니다!</WelcomeText>
      </ImgContainer>
      <BottomInfoContainer>
        {info.ticketNo?.map((ticketNo, index) => (
          <Ticket ticketNo={ticketNo} key={index} />
        ))}
        <TicketDetailContainer>
          <TicketDetailText>토너먼트 참가 안내에서 상세 일정을 확인해주세요.</TicketDetailText>
          <TicketDetailText>메인이벤트 참가 시 직원분께 QR 코드를 보여주세요.</TicketDetailText>
        </TicketDetailContainer>
      </BottomInfoContainer>

      <BottomTabContainer>
        <GoOfflineEventDetailBtn onClick={goOfflineTab}>
          오프라인 이벤트 참가안내
        </GoOfflineEventDetailBtn>
      </BottomTabContainer>
    </>
  );
};

const WelcomeText = styled.h4`
  font-family: 'Gmarket';
  font-weight: 500;
  font-size: 40px;
  line-height: 46px;
  letter-spacing: -0.06em;
  color: #8fcdff;
  text-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);

  ${mobileQuery} {
    font-size: 21px;
    line-height: 26px;
  }
`;

const ImgContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 13px;
  margin-bottom: 15px;
  padding-left: 20px;
  padding-right: 20px;
`;

const BottomInfoContainer = styled.div`
  width: 100%;
  max-width: 1000px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 180px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media screen and (max-width: 720px) {
    padding-bottom: 130px;
  }
`;

const BottomTabContainer = styled.div`
  position: fixed;
  bottom: 0;
  z-index: 10;
  max-width: 1000px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;

  background: linear-gradient(90deg, rgba(25, 36, 255, 0.85) 39.5%, rgba(77, 14, 166, 0.85) 100%);

  backdrop-filter: blur(25px);
`;

const GoOfflineEventDetailBtn = styled.button`
  height: 100%;
  left: 0%;
  width: 100%;
  height: 70px;

  font-weight: 700;
  font-size: 21px;
  line-height: 24px;
  letter-spacing: -0.04em;

  color: #ffffff;
`;

const TicketDetailContainer = styled.ul`
  padding-left: 10px;
  margin: 0;
  margin-top: 10px;
`;

const TicketDetailText = styled.li`
  font-weight: 500;
  font-size: 26px;
  line-height: 36px;
  letter-spacing: -0.04em;

  color: #939393;

  ${mobileQuery} {
    font-size: 16px;
    line-height: 24px;
  }
`;
